import { render, staticRenderFns } from "./OkPopup.vue?vue&type=template&id=2695e0ba&"
import script from "./OkPopup.vue?vue&type=script&lang=ts&"
export * from "./OkPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports